:host {
  display: block;
}

.vs-marquee-wrapper .vs-marquee-item {
  word-break: break-word !important;
}

.vs-marquee-wrapper-v2 {
  .vs-marquee-item {
    flex: 1;
  }
}

// Skeleton loader styles
.vs-marquee-v2-skeleton {
  width: 100%;
  height: 0;
  padding-bottom: 37.5%;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  
  @keyframes shimmer {
    0% { background-position: -1200px 0; }
    100% { background-position: 1200px 0; }
  }

  background: linear-gradient(90deg, #e0e0e0 0%, #e8e8e8 50%, #e0e0e0 100%);
  background-size: 1200px 100%;
  animation: shimmer 2s infinite linear;

  @media (max-width: 767px) {
    padding-bottom: 56.25%;
  }
  
  @media (max-width: 480px) {
    padding-bottom: 75%;
  }
}